import { gate } from 'hub-http/gates';
export const AGENT_INBOX_GLOBAL_NAV = gate('AIRuntime::AgentInbox::GlobalNav');
export const CREATE_AGENT = gate('Workflows:ModernEditor');
export const CREATE_AGENT_AS_STARTER_PORTAL = gate('Breeze:AgentAccessStarterHoldover');
export const WORKFLOWS_MODERN_EDITOR = gate('Workflows:ModernEditor');
export const TOOLS_AUDIT = gate('AgentBuilder:ToolsAudit');
export const BROKEN_WORKFLOWS_WARNING = gate('AgentBuilder:BrokenWorkflowsWarning');
export const CUSTOM_ASSISTANT_CREATION = gate('BreezeAssistant:CustomAssistant:Creation');
export const ALLOW_DRAFT_AGENTS_IN_WORKFLOWS = gate('AgentBuilder:AllowDraftAgentsInWorkflows');
export const UNPUBLISH_AGENTS = gate('AgentBuilder:UnpublishAgents');